export default function guideGenerator(data) {
  return `
   <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="stylesheet" href="./vars.css">
  <style>
   a,
   button,
   input,
   select,
   h1,
   h2,
   h3,
   h4,
   h5,
   * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       border: none;
       text-decoration: none;
       background: none;
   
       -webkit-font-smoothing: antialiased;
   }
   
   menu, ol, ul {
       list-style-type: none;
       margin: 0;
       padding: 0;
   }
   .frame-1,
.frame-1 * {
  box-sizing: border-box;
}
.frame-1 {
  background: #ffffff;
  height: 1007px;
  position: relative;
  overflow: hidden;
}
.creacion-de-un-transito {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 20px;
  font-weight: 400;
  position: absolute;
  left: 13px;
  top: 6px;
  width: 729px;
  -webkit-text-stroke: 1px #000000;
}
.rectangle-1 {
  background: #ffffff;
  border-style: solid;
  border-color: #000000;
  border-width: 2px;
  width: 734px;
  height: 922px;
  position: absolute;
  left: 13px;
  top: 30px;
}
.documento {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 29px;
  top: 39px;
}
.rectangle-2 {
  background: #eeeded;
  border-style: solid;
  border-color: #000000;
  border-width: 1px;
  width: 15px;
  height: 12px;
  position: absolute;
  left: 115px;
  top: 39px;
}
.rectangle-6 {
  background: #eeeded;
  border-style: solid;
  border-color: #000000;
  border-width: 1px;
  width: 15px;
  height: 12px;
  position: absolute;
  left: 201px;
  top: 39px;
}
.duca-t {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 139px;
  top: 39px;
}
.duca-f {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 236px;
  top: 39px;
}
.pa-s-digitaci-n-duca {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 380px;
  top: 39px;
}
.rectangle-5 {
  background: #eeeded;
  width: 341px;
  height: 21px;
  position: absolute;
  left: 18px;
  top: 79px;
}
.rectangle-7 {
    background: #eeeded;
    width: 381px;
    height: 21px;
    position: absolute;
    left: 364px;
    top: 79px;
}
.rectangle-9 {
    background: #eeeded;
    width: 381px;
    height: 21px;
    position: absolute;
    left: 364px;
    top: 134px;
}
.rectangle-60 {
    background: #eeeded;
    width: 261px;
    height: 20px;
    position: absolute;
    left: 483px;
    top: 35px;
}
.guatemala {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 491px;
  top: 40px;
  width: 183px;
}

._1-exportador {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 62px;
}
.son-4-636-bultos-conteniendo-48-pallets {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 18px;
  top: 971px;
  width: 720px;
  height: 11px;
}
.industrias-alas-verdes-s-a-de-c-v {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 79px;
  width: 341px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
._2-direcci-n {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 117px;
}
.rectangle-4 {
    background: #eeeded;
    width: 346px;
    height: 54px;
    position: absolute;
    left: 15px;
    top: 133px;
}
.km-34-boulevard-del-ejercito-nacional-y-10-ave-norte-barrio-la-avenida-san-juan-y-calle-sur-de-la-calle-esto-es-una-prueba-donde-se-van-a-mostrar-una-direccion-casi-completo-de-un-lugar-con-algunos-limites-de-caracteres {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 18px;
  top: 134px;
  width: 333px;
  height: 49px;
}
.rectangle-10 {
    background: #eeeded;
    width: 346px;
    height: 21px;
    position: absolute;
    left: 15px;
    top: 207px;
}
.rectangle-12 {
    background: #eeeded;
    width: 381px;
    height: 21px;
    position: absolute;
    left: 364px;
    top: 207px;
}
.rectangle-14 {
    background: #eeeded;
    width: 381px;
    height: 26px;
    position: absolute;
    left: 364px;
    top: 290px;
}
// .rectangle-16 {
//   background: #d9d9d9;
//   width: 158px;
//   height: 21px;
//   position: absolute;
//   left: 19px;
//   top: 346px;
// }
.rectangle-25 {
    background: #eeeded;
    width: 347px;
    height: 25px;
    position: absolute;
    left: 15px;
    top: 346px;
}
// .rectangle-28 {
//   background: #d9d9d9;
//   width: 159px;
//   height: 22px;
//   position: absolute;
//   left: 202px;
//   top: 465px;
// }
// .rectangle-27 {
//   background: #d9d9d9;
//   width: 72px;
//   height: 21px;
//   position: absolute;
//   left: 125px;
//   top: 466px;
// }
.rectangle-26 {
    background: #eeeded;
    width: 730px;
    height: 28px;
    position: absolute;
    left: 15px;
    top: 466px;
}
// .rectangle-30 {
//   background: #d9d9d9;
//   width: 159px;
//   height: 21px;
//   position: absolute;
//   left: 579px;
//   top: 466px;
// }
// .rectangle-29 {
//   background: #d9d9d9;
//   width: 199px;
//   height: 21px;
//   position: absolute;
//   left: 370px;
//   top: 466px;
// }
.guatemalteco {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 372px;
  top: 466px;
  width: 195px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.rectangle-21 {
    background: #eeeded;
    width: 381px;
    height: 30px;
    position: absolute;
    left: 364px;
    top: 394px;
}
.rectangle-20 {
    background: #eeeded;
    width: 347px;
    height: 30px;
    position: absolute;
    left: 15px;
    top: 394px;
}

.transportes-ouran-high-school {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 372px;
  top: 211px;
  width: 336px;
  height: 19px;
}

.rectangle-18 {
    background: #eeeded;
    width: 380px;
    height: 25px;
    position: absolute;
    left: 365px;
    top: 346px;
}
.rectangle-31 {
    background: #eeeded;
    width: 730px;
    height: 23px;
    position: absolute;
    left: 15px;
    top: 513px;
}

.rectangle-58 {
    background: #eeeded;
    width: 730px;
    height: 26px;
    position: absolute;
    left: 15px;
    top: 622px;
}

.rectangle-38 {
    background: #eeeded;
    width: 730px;
    height: 25px;
    position: absolute;
    left: 15px;
    top: 579px;
}

.rectangle-44 {
    background: #eeeded;
    width: 730px;
    height: 25px;
    position: absolute;
    left: 15px;
    top: 686px;
}
.rectangle-50 {
    background: #eeeded;
    width: 730px;
    height: 26px;
    position: absolute;
    left: 15px;
    top: 729px;
}
._24-000-00 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 265px;
  top: 690px;
  height: 12px;
}

.rectangle-13 {
    background: #eeeded;
    width: 381px;
    height: 21px;
    position: absolute;
    left: 364px;
    top: 248px;
}
.sv-0001 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 372px;
  top: 248px;
  width: 103px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.consignatario {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 16px;
  top: 193px;
  width: 81px;
}
.industrias-alas-verdes-s-a-de-c-v2 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 208px;
  width: 341px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
._7-direcci-n {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 245px;
}
.rectangle-11 {
    width: 346px;
    height: 52px;
    position: absolute;
    left: 15px;
    top: 262px;
    overflow: visible;
    background: #eeeded;
}
.avenida-san-juan-y-calle-sur-de-la-calle-esto-es-una-prueba-donde-se-van-a-mostrar-una-direccion-casi-completo-de-un-lugar-con-algunos-limites-de-caracteres {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 262px;
  width: 331px;
  height: 49px;
}
.rectangle-22 {
  background: #d9d9d9;
  width: 730px;
  height: 20px;
  position: absolute;
  left: 15px;
  top: 538px;
}
.rectangle-43 {
  background: #d9d9d9;
  width: 730px;
  height: 20px;
  position: absolute;
  left: 15px;
  top: 648px;
}
.rectangle-37 {
  background: #d9d9d9;
  width: 730px;
  height: 20px;
  position: absolute;
  left: 15px;
  top: 423px;
}
.line-1 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 919px;
  height: 0px;
  position: absolute;
  left: 363px;
  top: 32px;
  transform-origin: 0 0;
  transform: rotate(89.875deg) scale(1, 1);
}
.line-2 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 59px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
._3-aduana-de-partida {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 63px;
  height: 15px;
}
._5-fecha {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 577px;
  top: 63px;
  width: 48px;
  height: 15px;
}
._4-aduana-destino {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 120px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.el-amatillo {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 370px;
  top: 79px;
  width: 191px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
._2025-03-27 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 579px;
  top: 84px;
}
.pe-as-blancas {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 139px;
  width: 191px;
  height: 21px;
}

._8-transportista {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 193px;
  height: 15px;
}
._9-c-digo-de-transportista {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 232px;
}
._10-nombre-del-conductor {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 277px;
}
._11-nacionalidad-conductor {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 581px;
  top: 277px;
  width: 156px;
  height: 18px;
}
.line-4 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 734px;
  height: 0px;
  position: absolute;
  left: 747px;
  top: 320px;
  transform-origin: 0 0;
  transform: rotate(-179.844deg) scale(1, 1);
}
._12-no-documento-de-identidad {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 327px;
 
}
._13-pa-s-documento-de-identidad {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 197px;
  top: 327px;
}
._14-no-de-licencia-de-conducir {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 327px;
}
._15-pa-s-licencia-de-conducir {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 552px;
  top: 327px;
  width: 137px;
  height: 16px;
}
._16-pa-s-procedencia {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 376px;
  height: 11px;
}
._17-pa-s-destino {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 379px;
  width: 74px;
  height: 14px;
}
.line-3 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 733px;
  height: 0px;
  position: absolute;
  left: 14px;
  top: 190px;
  transform-origin: 0 0;
  transform: rotate(-0.078deg) scale(1, 1);
}
.line-5 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 733px;
  height: 0px;
  position: absolute;
  left: 13px;
  top: 373px;
}
.rectangle-23 {
  background: #d9d9d9;
  width: 17px;
  height: 19px;
  position: absolute;
  left: 356px;
  top: 423px;
}
.line-6 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 13px;
  top: 424px;
  transform-origin: 0 0;
  transform: rotate(-0.078deg) scale(1, 1);
}
.datos-de-la-unidad-de-transporte {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  left: 25px;
  top: 427px;
  width: 343px;
  height: 15px;
  -webkit-text-stroke: 1px #000000;
}
.datos-del-remolque {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  left: 25px;
  top: 541px;
  width: 343px;
  height: 15px;
  -webkit-text-stroke: 1px #000000;
}
.datos-de-la-mercaderia {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  left: 25px;
  top: 650px;
  width: 330px;
  height: 15px;
  -webkit-text-stroke: 1px #000000;
}
._18-matr-cula-placa {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 449px;
}
.rectangle-24 {
  background: #d9d9d9;
  width: 730px;
  height: 195px;
  position: absolute;
  left: 15px;
  top: 755px;
}
.no-de-bultos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 129px;
  top: 758px;
  width: 60px;
  height: 30px;
}
.facturas {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 33px;
  top: 762px;
}
._19-no-ejes {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 125px;
  top: 449px;
  height: 15px;
}
._21-pa-s-de-registro {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 449px;
}
._22-marca {
    color: #000000;
    text-align: center;
    font-family: "Inter-Regular", sans-serif;
    font-size: 10px;
    font-weight: 400;
    position: absolute;
    left: 579px;
    top: 449px;
    height: 15px;
}
._23-n-mero-de-motor {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 497px;
}
._24-n-mero-de-chasis {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 206px;
  top: 497px;
  height: 15px;
}
._25-tara-equipo {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 497px;
}
._26-tipo-de-camion {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 471px;
  top: 497px;
}
.rectangle-36 {
  background: #d9d9d9;
  width: 7px;
  height: 11px;
  position: absolute;
  left: 361px;
  top: 542px;
}
.rectangle-55 {
  background: #d9d9d9;
  width: 7px;
  height: 20px;
  position: absolute;
  left: 361px;
  top: 538px;
}
.rectangle-56 {
  background: #d9d9d9;
  width: 7px;
  height: 20px;
  position: absolute;
  left: 361px;
  top: 648px;
}
.line-10 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 559px;
  transform-origin: 0 0;
  transform: rotate(-0.078deg) scale(1, 1);
}
._27-matr-cula {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 564px;
  height: 15px;
}
._28-no-ejes {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 130px;
  top: 564px;
  width: 68px;
  height: 15px;
}
._29-tara {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 234px;
  top: 564px;
  width: 46px;
  height: 15px;
}
._30-pa-s-de-registro {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 564px;
  height: 15px;
}
.line-11 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 648px;
  transform-origin: 0 0;
  transform: rotate(0.157deg) scale(1, 1);
}
._34-peso-neto-total {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 672px;
  height: 15px;
}
._35-peso-bruto-total {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 123px;
  top: 672px;
  width: 115px;
  height: 15px;
}
._36-valor-total {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 255px;
  top: 672px;
  width: 82px;
  height: 15px;
}
._37-no-items {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 672px;
  height: 15px;
}
._38-valor-flete {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 471px;
  top: 672px;
  height: 15px;
}
.valor-flete-dinero{
color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 471px;
  top: 690px;
  height: 15px;
}
.valor-seguro-dinero{
color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 606px;
  top: 690px;
  height: 15px;
}
._39-valor-seguro {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 606px;
  top: 672px;
  height: 15px;
}
._40-otros-gastos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 714px;
  height: 15px;
}
._41-incoterms {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 136px;
  top: 714px;
  height: 15px;
}
._42-cantidad-bultos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 265px;
  top: 714px;
  height: 15px;
}
._43-pa-s-de-emisi-n-de-documentos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 715px;
  height: 15px;
}
.rectangle-54 {
  background: #ccffff;
  width: 730px;
  height: 164px;
  position: absolute;
  left: 15px;
  top: 787px;
}
.f-123244451 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 790px;
  width: 74px;
}
.f-123244459 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 936px;
  width: 74px;
}
.f-123244458 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 918px;
  width: 74px;
}
.f-123244457 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 898px;
  width: 74px;
}
.f-123244455 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 862px;
  width: 74px;
}
.f-123244454 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 844px;
  width: 74px;
}
.line-16 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 196px;
  height: 0px;
  position: absolute;
  left: 135px;
  top: 755px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-17 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 196px;
  height: 0px;
  position: absolute;
  left: 182px;
  top: 755px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.clase-de-bultos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 178px;
  top: 758px;
  width: 54px;
  height: 30px;
}
.line-18 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 198px;
  height: 0px;
  position: absolute;
  left: 229px;
  top: 755px;
  transform-origin: 0 0;
  transform: rotate(90.289deg) scale(1, 1);
}
.contenido-productos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 263px;
  top: 765px;
  width: 128px;
  height: 15px;
}
.line-19 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 196px;
  height: 0px;
  position: absolute;
  left: 409px;
  top: 756px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.partida-arancelaria {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 426px;
  top: 758px;
  width: 68px;
  height: 34px;
}
.line-20 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 195px;
  height: 0px;
  position: absolute;
  left: 506px;
  top: 756px;
  transform-origin: 0 0;
  transform: rotate(90.294deg) scale(1, 1);
}
.valor-mercader-a {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 512px;
  top: 758px;
  width: 66px;
  height: 30px;
}
.line-21 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 196px;
  height: 0px;
  position: absolute;
  left: 585px;
  top: 756px;
  transform-origin: 0 0;
  transform: rotate(90.287deg) scale(1, 1);
}
.peso-neto-kg {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 591px;
  top: 759px;
  width: 63px;
  height: 30px;
}
.line-22 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 196px;
  height: 0px;
  position: absolute;
  left: 661px;
  top: 756px;
  transform-origin: 0 0;
  transform: rotate(90.006deg) scale(1, 1);
}
.peso-bruto-kg {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 678px;
  top: 758px;
  width: 55px;
}
.line-7 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 731px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 445px;
  transform-origin: 0 0;
  transform: rotate(-0.078deg) scale(1, 1);
}
._20-color-y-detalles {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 202px;
  top: 449px;
  height: 15px;
}
.line-8 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 733px;
  height: 0px;
  position: absolute;
  left: 13px;
  top: 493px;
  transform-origin: 0 0;
  transform: rotate(0.157deg) scale(1, 1);
}
.line-9 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 538px;
}
.line-12 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 733px;
  height: 0px;
  position: absolute;
  left: 14px;
  top: 670px;
}
.line-13 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 14px;
  top: 713px;
}
.line-14 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 755px;
  transform-origin: 0 0;
  transform: rotate(0.08deg) scale(1, 1);
}
.line-15 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 13px;
  top: 787px;
}
.f-123244456 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 880px;
  width: 74px;
}
.f-123244452 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 808px;
  width: 74px;
}
.f-123244453 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 17px;
  top: 826px;
  width: 74px;
}
.line-23 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 805px;
  transform-origin: 0 0;
  transform: rotate(0.157deg) scale(1, 1);
}
.line-24 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 823px;
  transform-origin: 0 0;
  transform: rotate(0.157deg) scale(1, 1);
}
._322 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
      left: 127px;
  top: 790px;
  width: 65px;
  height: 18px;
}
._3222 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 808px;
  width: 65px;
  height: 18px;
}
._3223 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 936px;
  width: 65px;
  height: 18px;
}
._3224 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 918px;
  width: 65px;
  height: 18px;
}
._3225 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 898px;
  width: 65px;
  height: 18px;
}
._3226 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 880px;
  width: 65px;
  height: 18px;
}
._3227 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 862px;
  width: 65px;
  height: 18px;
}
._3228 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 844px;
  width: 65px;
  height: 18px;
}
._3229 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 127px;
  top: 826px;
  width: 65px;
  height: 18px;
}
.pts {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 790px;
  width: 68px;
  height: 15px;
}
.pts2 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 936px;
  width: 68px;
  height: 15px;
}
.pts3 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 918px;
  width: 68px;
  height: 15px;
}
.pts4 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 898px;
  width: 68px;
  height: 15px;
}
.pts5 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 880px;
  width: 68px;
  height: 15px;
}
.pts6 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 862px;
  width: 68px;
  height: 15px;
}
.pts7 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 844px;
  width: 68px;
  height: 15px;
}
.pts8 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 826px;
  width: 68px;
  height: 15px;
}
.pts9 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 170px;
  top: 808px;
  width: 68px;
  height: 15px;
}
.alimentos {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 790px;
}
.alimentos2 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 936px;
}
.alimentos3 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 918px;
}
.alimentos4 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 898px;
}
.alimentos5 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 880px;
}
.alimentos6 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 862px;
}
.alimentos7 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 844px;
}
.alimentos8 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 826px;
}
.alimentos9 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 235px;
  top: 808px;
}
.a-1-s-2-d-3-f-4-g-5-h {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
      left: 413px;
  top: 790px;
}
.a-1-s-2-d-3-f-4-g-5-h2 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
      left: 413px;
  top: 936px;
}
.a-1-s-2-d-3-f-4-g-5-h3 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
      left: 413px;
  top: 918px;
}
.a-1-s-2-d-3-f-4-g-5-h4 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
      left: 413px;
  top: 898px;
}
.a-1-s-2-d-3-f-4-g-5-h5 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
     left: 413px;
  top: 880px;
}
.a-1-s-2-d-3-f-4-g-5-h6 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
     left: 413px;
  top: 862px;
}
.a-1-s-2-d-3-f-4-g-5-h7 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 413px;
  top: 844px;
}
.a-1-s-2-d-3-f-4-g-5-h8 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 413px;
  top: 826px;
}
.a-1-s-2-d-3-f-4-g-5-h9 {
  color: #000000;
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
    left: 413px;
  top: 808px;
}
._10-200-20 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 790px;
  width: 64px;
  height: 15px;
}
._10-200-202 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 935px;
  width: 64px;
  height: 15px;
}
._10-200-203 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 917px;
  width: 64px;
  height: 15px;
}
._10-200-204 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 899px;
  width: 64px;
  height: 15px;
}
._10-200-205 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 879px;
  width: 64px;
  height: 15px;
}
._10-200-206 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 861px;
  width: 64px;
  height: 15px;
}
._10-200-207 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 844px;
  width: 64px;
  height: 15px;
}
._10-200-208 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 827px;
  width: 64px;
  height: 15px;
}
._10-200-209 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 595px;
  top: 808px;
  width: 64px;
  height: 15px;
}
._14-000-00 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 790px;
  width: 64px;
  height: 15px;
}
._14-000-002 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 936px;
  width: 64px;
  height: 15px;
}
._14-000-003 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 916px;
  width: 64px;
  height: 15px;
}
._14-000-004 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 898px;
  width: 64px;
  height: 15px;
}
._14-000-005 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 880px;
  width: 64px;
  height: 15px;
}
._14-000-006 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 861px;
  width: 64px;
  height: 15px;
}
._14-000-007 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 843px;
  width: 64px;
  height: 15px;
}
._14-000-008 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
 left: 681px;
  top: 827px;
  width: 64px;
  height: 15px;
}
._14-000-009 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 681px;
  top: 808px;
  width: 64px;
  height: 15px;
}
.line-25 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 841px;
  transform-origin: 0 0;
  transform: rotate(0.078deg) scale(1, 1);
}
.line-26 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 860px;
  transform-origin: 0 0;
  transform: rotate(-0.151deg) scale(1, 1);
}
.line-27 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 878px;
  transform-origin: 0 0;
  transform: rotate(-0.157deg) scale(1, 1);
}
.line-28 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 896px;
  transform-origin: 0 0;
  transform: rotate(-0.157deg) scale(1, 1);
}
.line-29 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 730px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 914px;
  transform-origin: 0 0;
  transform: rotate(-0.078deg) scale(1, 1);
}
.line-30 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 934px;
  transform-origin: 0 0;
  transform: rotate(-0.156deg) scale(1, 1);
}
._12-000 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 790px;
  width: 76px;
  height: 17px;
  display: flex;
  justify-content: flex-end;
}
._12-0002 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 809px;
  width: 76px;
  height: 17px;
  justify-content: flex-end;
}
._12-0003 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 933px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._12-0004 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 913px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._12-0005 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 894px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._12-0006 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 876px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._12-0007 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 858px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._12-0008 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 841px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._12-0009 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 506px;
  top: 823px;
  width: 76px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.manolito {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 372px;
  top: 291px;
  width: 200px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.guatemalteco2 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 601px;
  width: 143px;
  top: 291px;
  height: 21px;
  display: flex
;
  align-items: center;
  justify-content: flex-start;
}
.c-999999 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 352px;
  width: 140px;
  height: 17px;
}
.guatemalteco3 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 200px;
  top: 347px;
  width: 153px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.guatemala2 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 22px;
  top: 400px;
  width: 173px;
  height: 18px;
}
._0012505302 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 373px;
  top: 346px;
  width: 155px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.guatemalteco4 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 557px;
  top: 346px;
  width: 155px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.el-salvador {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 374px;
  top: 400px;
  width: 175px;
  height: 14px;
}
._2 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 126px;
  top: 472px;
  height: 15px;
}
._22 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 138px;
  top: 582px;
  height: 15px;
}
._23 {
  color: #000000;
  text-align: right;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 689px;
  height: 15px;
}
.rojo-con-franjas-azules-y-nombre {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 203px;
  top: 470px;
  width: 158px;
  height: 17px;
}
.freightliner {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 581px;
  top: 466px;
  width: 155px;
  height: 18px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.ufy-00-db-000-fy-000 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 517px;
  width: 149px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.idem {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 206px;
  top: 517px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
._7000 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 372px;
  top: 517px;
  width: 82px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.cabezal-24-toneladas-con-camarote-pero-al-regreso-sin {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 471px;
  top: 517px;
  width: 275px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.re-000-000 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 582px;
  width: 89px;
  height: 16px;
}
._6000 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 241px;
  top: 582px;
  width: 89px;
}
.guatemalteco5 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 372px;
  top: 582px;
  width: 163px;
}
._31-marca {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 608px;
  height: 11px;
}
._32-dimensiones {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 239px;
  top: 608px;
  width: 79px;
  height: 16px;
}
._33-color-y-detalles {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 608px;
  height: 12px;
}
.fruehauf {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 627px;
  width: 145px;
}
._45-x-34-x-45-x-1000 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
      left: 240px;
    top: 627px;
    width: 120px;
  height: 13px;
}
.blanco-con-franjas-azules {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 626px;
  width: 347px;
  height: 14px;
}
._20-400-40 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 20px;
  top: 690px;
  width: 99px;
  height: 16px;
}
._28-000-00 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 137px;
  top: 690px;
  width: 107px;
}
._12-000-00 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 479px;
  top: 690px;
  width: 99px;
}
._34-00 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 614px;
  top: 690px;
  width: 94px;
}
._30-000 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 26px;
  top: 733px;
  width: 91px;
}
.fca {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 136px;
  top: 733px;
  width: 80px;
  height: 12px;
}
._77 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 266px;
  top: 733px;
}
.guatemala3 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 371px;
  top: 733px;
  width: 184px;
}
.observaciones {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 19px;
  top: 959px;
}
.line-32 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 15px;
  height: 0px;
  position: absolute;
  left: 13px;
  top: 969px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-33 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 734px;
  height: 0px;
  position: absolute;
  left: 13px;
  top: 984px;
  transform-origin: 0 0;
  transform: rotate(-0.078deg) scale(1, 1);
}
.line-31 {
  margin-top: -2px;
  border-style: solid;
  border-color: #000000;
  border-width: 2px 0 0 0;
  width: 732px;
  height: 0px;
  position: absolute;
  left: 14px;
  top: 604px;
  transform-origin: 0 0;
  transform: rotate(0.157deg) scale(1, 1);
}
.p-103-03 {
  color: #000000;
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  left: 22px;
  top: 469px;
  width: 92px;
  height: 16px;
}
.otros-gastos-dinero{
color: #000000;
    text-align: left;
    font-family: "Inter-Regular", sans-serif;
    font-size: 10px;
    font-weight: 400;
    position: absolute;
    left: 19px;
    top: 733px;
    width: 91px;
}
   </style>
  <title>Document</title>
</head>
<body>
  <div class="frame-1">
    <div class="creacion-de-un-transito">CREACION DE UN TRANSITO</div>
    <div class="rectangle-1"></div>
    <div class="documento">Documento:</div>
    <div class="rectangle-2"></div>
    <div class="rectangle-6"></div>
    <div class="duca-t">DUCA T</div>
    <div class="duca-f">DUCA F</div>
    <div class="pa-s-digitaci-n-duca">País digitación Duca:</div>
    <div class="rectangle-5"></div>
    <div class="rectangle-7"></div>
    <div class="rectangle-9"></div>
    <div class="rectangle-60"></div>
    <div class="guatemala">${data?.paisOrigen}</div>
    <div class="rectangle-8"></div>
    <div class="_1-exportador">1. Exportador</div>
    <div class="industrias-alas-verdes-s-a-de-c-v">
    ${data.exportador}
    </div>
    <div class="_2-direcci-n">2. Dirección</div>
    <div class="rectangle-4"></div>
    <div
      class="km-34-boulevard-del-ejercito-nacional-y-10-ave-norte-barrio-la-avenida-san-juan-y-calle-sur-de-la-calle-esto-es-una-prueba-donde-se-van-a-mostrar-una-direccion-casi-completo-de-un-lugar-con-algunos-limites-de-caracteres"
    >
    ${data.dexportador}
    </div>
    <div class="rectangle-10"></div>
    <div class="rectangle-12"></div>
    <div class="rectangle-14"></div>
    <div class="rectangle-16"></div>
    <div class="rectangle-25"></div>
    <div class="rectangle-28"></div>
    <div class="rectangle-27"></div>
    <div class="rectangle-26"></div>
    <div class="rectangle-30"></div>
    <div class="rectangle-29"></div>
    <div class="guatemalteco">${data.dNacionalidad}</div>
    <div class="rectangle-21"></div>
    <div class="rectangle-20"></div>
    <div class="rectangle-17"></div>
    <div class="transportes-ouran-high-school">${data?.transportista.toUpperCase()}</div>
    <div class="rectangle-19"></div>
    <div class="rectangle-18"></div>
    <div class="rectangle-31"></div>
    <div class="rectangle-42"></div>
    <div class="rectangle-58"></div>
    <div class="rectangle-59"></div>
    <div class="rectangle-57"></div>
    <div class="rectangle-38"></div>
    <div class="rectangle-39"></div>
    <div class="rectangle-40"></div>
    <div class="rectangle-44"></div>
    <div class="rectangle-51"></div>
    <div class="rectangle-52"></div>
    <div class="rectangle-53"></div>
    <div class="rectangle-50"></div>
    <div class="rectangle-48"></div>
    <div class="rectangle-49"></div>
    <div class="rectangle-47"></div>
    <div class="rectangle-46"></div>
    <div class="_24-000-00">
    ${data.valorTotal}
      <br />
    </div>
    <div class="rectangle-45"></div>
    <div class="rectangle-41"></div>
    <div class="rectangle-34"></div>
    <div class="rectangle-35"></div>
    <div class="rectangle-32"></div>
    <div class="rectangle-15"></div>
    <div class="rectangle-13"></div>
    <div class="sv-0001">${data.codigoTransportista}</div>
    <div class="consignatario">
      <ol class="consignatario-span">
        <li>6. Consignatario</li>
      </ol>
    </div>
    <div class="industrias-alas-verdes-s-a-de-c-v2">
      Industrias Alas Verdes, S.A. de C.V.
    </div>
    <div class="_7-direcci-n">7. Dirección</div>
    <div class="rectangle-11"></div>
    <div
      class="avenida-san-juan-y-calle-sur-de-la-calle-esto-es-una-prueba-donde-se-van-a-mostrar-una-direccion-casi-completo-de-un-lugar-con-algunos-limites-de-caracteres"
    >
    ${data.direccionConsignatario}
    </div>
    <div class="rectangle-22"></div>
    <div class="rectangle-43"></div>
    <div class="rectangle-37"></div>
    <div class="line-1"></div>
    <div class="line-2"></div>
    <div class="_3-aduana-de-partida">
      3. Aduana de Partida
      <br />
    </div>
    <div class="_5-fecha">
      5. Fecha
      <br />
    </div>
    <div class="_4-aduana-destino">4. Aduana Destino</div>
    <div class="el-amatillo">${data.aduanaSalida}</div>
    <div class="_2025-03-27">
    ${data.fechaExpedicionFormateada}
      <br />
    </div>
    <div class="pe-as-blancas">
    ${data.aduanaDestino}
      <br />
    </div>
    <div class="_8-transportista">
      8. Transportista
      <br />
    </div>
    <div class="_9-c-digo-de-transportista">9. Código de Transportista</div>
    <div class="_10-nombre-del-conductor">10. Nombre del Conductor</div>
    <div class="_11-nacionalidad-conductor">
      11. Nacionalidad Conductor
      <br />
    </div>
    <div class="line-4"></div>
    <div class="_12-no-documento-de-identidad">
      12. No. Documento de Identidad
    </div>
    <div class="_13-pa-s-documento-de-identidad">
      13. País Documento de Identidad
    </div>
    <div class="_14-no-de-licencia-de-conducir">
      14. No. de Licencia de conducir
    </div>
    <div class="_15-pa-s-licencia-de-conducir">
      15. País Licencia de conducir
      <br />
    </div>
    <div class="_16-pa-s-procedencia">
      16. País Procedencia
      <br />
    </div>
    <div class="_17-pa-s-destino">
      17. País Destino
      <br />
    </div>
    <div class="line-3"></div>
    <div class="line-5"></div>
    <div class="rectangle-23"></div>
    <div class="line-6"></div>
    <div class="datos-de-la-unidad-de-transporte">
      DATOS DE LA UNIDAD DE TRANSPORTE
      <br />
    </div>
    <div class="datos-del-remolque">
      DATOS DEL REMOLQUE
      <br />
    </div>
    <div class="datos-de-la-mercaderia">
      DATOS DE LA MERCADERIA
      <br />
    </div>
    <div class="_18-matr-cula-placa">18. Matrícula placa</div>
    <div class="rectangle-24"></div>
    <div class="no-de-bultos">
      No. de Bultos
      <br />
    </div>
    <div class="facturas">Facturas</div>
    <div class="_19-no-ejes">
      19. No. Ejes
      <br />
    </div>
    <div class="_21-pa-s-de-registro">21. País de Registro</div>
    <div class="_22-marca">
      22. Marca
      <br />
    </div>
    <div class="_23-n-mero-de-motor">23. Número De Motor</div>
    <div class="_24-n-mero-de-chasis">
      24. Número de Chasis
      <br />
    </div>
    <div class="_25-tara-equipo">25. Tara Equipo</div>
    <div class="_26-tipo-de-camion">26. Tipo de camion</div>
    <div class="rectangle-36"></div>
    <div class="rectangle-55"></div>
    <div class="rectangle-56"></div>
    <div class="line-10"></div>
    <div class="_27-matr-cula">
      27. Matrícula
      <br />
    </div>
    <div class="_28-no-ejes">
      28. No. Ejes
      <br />
    </div>
    <div class="_29-tara">
      29. Tara
      <br />
    </div>
    <div class="_30-pa-s-de-registro">
      30. País de Registro
      <br />
    </div>
    <div class="line-11"></div>
    <div class="_34-peso-neto-total">
      34. Peso Neto total
      <br />
    </div>
    <div class="_35-peso-bruto-total">
      35. Peso Bruto Total
      <br />
    </div>
    <div class="_36-valor-total">
      36. Valor Total
      <br />
    </div>
    <div class="_37-no-items">
      37. No. Items
      <br />
    </div>
    <div class="_38-valor-flete">
      38. Valor Flete
      <br />
    </div>
    <div class="_39-valor-seguro">
      39. Valor Seguro
      <br />
    </div>
    <div class="_40-otros-gastos">
      40. Otros gastos
      <br />
    </div>
    <div class="_41-incoterms">
      41. Incoterms
      <br />
    </div>
    <div class="_42-cantidad-bultos">
      42. Cantidad Bultos
      <br />
    </div>
    <div class="_43-pa-s-de-emisi-n-de-documentos">
      43. país de emisión de documentos
      <br />
    </div>
    <div class="rectangle-54"></div>
    <div class="f-123244451">${data?.factura}</div>
    <div class="f-123244459">${data?.factura9}</div>
    <div class="f-123244458">${data?.factura8}</div>
    <div class="f-123244457">${data?.factura7}</div>
    <div class="f-123244455">${data?.factura5}</div>
    <div class="f-123244454">${data?.factura4}</div>
    <div class="line-16"></div>
    <div class="line-17"></div>
    <div class="clase-de-bultos">
      Clase de Bultos
      <br />
    </div>
    <div class="line-18"></div>
    <div class="contenido-productos">
      Contenido / Productos
      <br />
    </div>
    <div class="line-19"></div>
    <div class="partida-arancelaria">
      Partida Arancelaria
      <br />
    </div>
    <div class="line-20"></div>
    <div class="valor-mercader-a">
      Valor Mercadería
      <br />
    </div>
    <div class="line-21"></div>
    <div class="peso-neto-kg">
      Peso Neto Kg.
      <br />
    </div>
    <div class="line-22"></div>
    <div class="peso-bruto-kg">
      Peso Bruto Kg.
      <br />
    </div>
    <div class="line-7"></div>
    <div class="_20-color-y-detalles">
      20. Color y detalles
      <br />
    </div>
    <div class="line-8"></div>
    <div class="line-9"></div>
    <div class="line-12"></div>
    <div class="line-13"></div>
    <div class="line-14"></div>
    <div class="line-15"></div>
    <div class="f-123244456">${data?.factura6}</div>
    <div class="f-123244452">${data?.factura2}</div>
    <div class="f-123244453">${data?.factura3}</div>
    <div class="line-23"></div>
    <div class="line-24"></div>
    <div class="_322">${data?.NoBulto}</div>
    <div class="_3222">${data?.NoBulto2}</div>
    <div class="_3223">${data?.NoBulto9}</div>
    <div class="_3224">${data?.NoBulto8}</div>
    <div class="_3225">${data?.NoBulto7}</div>
    <div class="_3226">${data?.NoBulto6}</div>
    <div class="_3227">${data?.NoBulto5}</div>
    <div class="_3228">${data?.NoBulto4}</div>
    <div class="_3229">${data?.NoBulto3}</div>
    <div class="pts">
    <td>${data?.claseBultos}
      <br />
    </div>
    <div class="pts2">
    ${data?.claseBultos9}
      <br />
    </div>
    <div class="pts3">
    ${data?.claseBultos8}
      <br />
    </div>
    <div class="pts4">
    ${data?.claseBultos7}
      <br />
    </div>
    <div class="pts5">
    ${data?.claseBultos6}
      <br />
    </div>
    <div class="pts6">
    ${data?.claseBultos5}
      <br />
    </div>
    <div class="pts7">
    ${data?.claseBultos4}
      <br />
    </div>
    <div class="pts8">
    ${data?.claseBultos3}
      <br />
    </div>
    <div class="pts9">
    ${data?.claseBultos2}
      <br />
    </div>
    <div class="alimentos">${data?.conteProducto}</div>
    <div class="alimentos2">${data?.conteProducto9}</div>
    <div class="alimentos3">${data?.conteProducto8}</div>
    <div class="alimentos4">${data?.conteProducto7}</div>
    <div class="alimentos5">${data?.conteProducto6}</div>
    <div class="alimentos6">${data?.conteProducto5}</div>
    <div class="alimentos7">${data?.conteProducto4}</div>
    <div class="alimentos8">${data?.conteProducto3}</div>
    <div class="alimentos9">${data?.conteProducto2}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h">${data?.arancelaria}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h2">${data?.arancelaria9}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h3">${data?.arancelaria8}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h4">${data?.arancelaria7}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h5">${data?.arancelaria6}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h6">${data?.arancelaria5}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h7">${data?.arancelaria4}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h8">${data?.arancelaria3}</div>
    <div class="a-1-s-2-d-3-f-4-g-5-h9">${data?.arancelaria2}</div>
    <div class="_10-200-20">
    ${data?.pesoNeto}
      <br />
    </div>
    <div class="_10-200-202">
    ${data?.pesoNeto9}
      <br />
    </div>
    <div class="_10-200-203">
    ${data?.pesoNeto8}
      <br />
    </div>
    <div class="_10-200-204">
    ${data?.pesoNeto7}
      <br />
    </div>
    <div class="_10-200-205">
    ${data?.pesoNeto6}
      <br />
    </div>
    <div class="_10-200-206">
    ${data?.pesoNeto5}
      <br />
    </div>
    <div class="_10-200-207">
    ${data?.pesoNeto4}
      <br />
    </div>
    <div class="_10-200-208">
    ${data?.pesoNeto3}
      <br />
    </div>
    <div class="_10-200-209">
    ${data?.pesoNeto2}
      <br />
    </div>
    <div class="_14-000-00">
    ${data?.pesoBruto}
      <br />
    </div>
    <div class="_14-000-002">
    ${data?.pesoBruto9}
      <br />
    </div>
    <div class="_14-000-003">
    ${data?.pesoBruto8}
      <br />
    </div>
    <div class="_14-000-004">
    ${data?.pesoBruto7}
      <br />
    </div>
    <div class="_14-000-005">
    ${data?.pesoBruto6}
      <br />
    </div>
    <div class="_14-000-006">
    ${data?.pesoBruto5}
      <br />
    </div>
    <div class="_14-000-007">
    ${data?.pesoBruto4}
      <br />
    </div>
    <div class="_14-000-008">
    ${data?.pesoBruto3}
      <br />
    </div>
    <div class="_14-000-009">
    ${data?.pesoBruto2}
      <br />
    </div>
    <div class="line-25"></div>
    <div class="line-26"></div>
    <div class="line-27"></div>
    <div class="line-28"></div>
    <div class="line-29"></div>
    <div class="line-30"></div>
    <div class="_12-000">${data?.valorMercaderia}</div>
    <div class="_12-0002">${data?.valorMercaderia2}</div>
    <div class="_12-0003">${data?.valorMercaderia9}</div>
    <div class="_12-0004">${data?.valorMercaderia8}</div>
    <div class="_12-0005">${data?.valorMercaderia7}</div>
    <div class="_12-0006">${data?.valorMercaderia6}</div>
    <div class="_12-0007">${data?.valorMercaderia5}</div>
    <div class="_12-0008">${data?.valorMercaderia4}</div>
    <div class="_12-0009">${data?.valorMercaderia3}</div>
    <div class="manolito">${data.piloto}</div>
    <div class="guatemalteco2">${data.nacionalidad}</div>
    <div class="c-999999">
    ${data.pasaporteNo}
      <br />
    </div>
    <div class="guatemalteco3">${data.cnacionalidad}</div>
    <div class="guatemala2">
    ${data.paisOrigen}
      <br />
    </div>
    <div class="_0012505302">${data.licenciaPiloto}</div>
    <div class="guatemalteco4">${data.bnacionalidad}</div>
    <div class="el-salvador">
    ${data.paisDestino}
      <br />
    </div>
    <div class="_2">
    ${data.noEjes}
      <br />
    </div>
    <div class="_22">
    ${data.Ejes}
      <br />
    </div>
    <div class="_23">
    ${data.Items}
      <br />
    </div>
    <div class="rojo-con-franjas-azules-y-nombre">
    ${data.ColorYDetalles}
      <br />
    </div>
    <div class="freightliner">${data.DMarca}</div>
    <div class="ufy-00-db-000-fy-000">${data.numeroMotor}</div>
    <div class="idem">${data.numeroChasis}</div>
    <div class="_7000">${data.taraEquipo}   </div>
    <div class="cabezal-24-toneladas-con-camarote-pero-al-regreso-sin">
    ${data.tipoCamino}
    </div>
    <div class="re-000-000">
    ${data.furgonPlaca}
      <br />
    </div>
    <div class="_6000">${data.tara}</div>
    <div class="guatemalteco5">${data.dNacionalidad}</div>
    <div class="_31-marca">
      31. Marca
      <br />
    </div>
    <div class="_32-dimensiones">
      32. Dimensiones
      <br />
    </div>
    <div class="_33-color-y-detalles">
      33. Color y detalles
      <br />
    </div>
    <div class="fruehauf">${data.fmarca}</div>
    <div class="_45-x-34-x-45-x-1000">
    ${data.dimensiones}
      <br />
    </div>
    <div class="blanco-con-franjas-azules">
    ${data.colorDetalles}
      <br />
    </div>
    <div class="_20-400-40">
    ${data.pesoNetoTotal}
      <br />
    </div>
    <div class="_28-000-00">${data.pesoBrutoTotal}</div>
    
    <div class="_12-000-00">${data.flete}</div>
    
    <div class="_34-00">${data.seguro}</div>
    
    <div class="_30-000">${data.otrosGastos}</div>
    <div class="fca">
    ${data.incoterms}
      <br />
    </div>
    <div class="_77">${data.cBultos}</div>
    <div class="guatemala3">${data.paisOrigen}</div>
    <div class="observaciones">OBSERVACIONES</div>
    <div class="son-4-636-bultos-conteniendo-48-pallets">
    ${data.observaciones}
      <br />
    </div>
    <div class="line-32"></div>
    <div class="line-33"></div>
    <div class="line-31"></div>
    <div class="p-103-03">
    ${data.cabezalPlaca}
      <br />
    </div>
  </div>
  
</body>
</html>`;
}
